import { render, staticRenderFns } from "./ProductsOneItem.vue?vue&type=template&id=0b4580ce&scoped=true"
import script from "./ProductsOneItem.vue?vue&type=script&lang=js"
export * from "./ProductsOneItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4580ce",
  null
  
)

export default component.exports